function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Rectangle");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "\\u5207\\u56FE",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u5185\\u5BB9\\u5236\\u4F5C-\\u97F3\\u9891\\u5236\\u4F5C-\\u5168\\u90E8\\u5185\\u5BB9",
  transform: "translate(-1146.000000, -505.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-19",
  transform: "translate(942.000000, 505.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-18",
  transform: "translate(204.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.68344316,16.1179305 C9.53234113,16.1320182 9.29239567,16.1148441 9.14708778,15.9695362 C9.14708778,15.9695362 5.59020677,12.6336277 5.43910475,12.4852334 L4.2439029,12.4852334 C3.57456639,12.4852334 3,11.9426295 3,11.2733876 L3,8.84969605 C3,8.18041634 3.57460426,7.63785026 4.24386503,7.63785026 L5.43991896,7.63785026 C5.59102098,7.4878086 9.14790199,4.15350958 9.14790199,4.15350958 C9.30538514,3.99602643 9.53315534,3.99102756 9.68425737,4.00511527 C9.99146027,4.03412383 10.2710558,4.32615973 10.2710558,4.56220457 C10.2735553,4.5887137 10.2752215,15.53348 10.2710558,15.5600081 C10.2710748,15.7905618 9.98981292,16.0888841 9.68344316,16.1179305 L9.68344316,16.1179305 Z M12.7123002,13.2337186 C12.4357532,13.5103224 11.9873703,13.5103224 11.7107665,13.2337186 C11.4342384,12.9571148 11.4342384,12.5085993 11.7107665,12.2319577 C12.9072938,11.0351653 12.9072938,9.08784268 11.7107665,7.89103135 C11.4342384,7.61440861 11.4342384,7.16594993 11.7107665,6.88932719 C11.8491252,6.75100636 12.0302961,6.68185541 12.2115428,6.68185541 C12.3927895,6.68185541 12.5740173,6.75100636 12.7122813,6.88925145 C14.4610505,8.63843724 14.4610505,11.4845328 12.7123002,13.2337186 L12.7123002,13.2337186 Z M15.1332462,14.5693999 C14.8567182,14.8460037 14.4083163,14.8459848 14.1317504,14.5693999 C13.8552034,14.2927961 13.8552034,13.8442995 14.1317504,13.5676579 C16.0645687,11.6343662 16.0645687,8.48867961 14.1317504,6.555369 C13.8552034,6.27872733 13.8552034,5.83021184 14.1317504,5.55360804 C14.2700712,5.41534401 14.4512421,5.34619306 14.6325267,5.34619306 C14.8137355,5.34619306 14.9950011,5.41534401 15.1332273,5.55366484 C16.3370067,6.75780405 17,8.35874702 17,10.0615608 C17.0000189,11.7644503 16.3370635,13.3653554 15.1332462,14.5693999 L15.1332462,14.5693999 Z",
  id: "Shape",
  fillOpacity: 0.45,
  fill: "#000000",
  transform: "translate(10.000000, 10.060968) scale(1, -1) translate(-10.000000, -10.060968) "
})))));

var SvgVolumeLound = function SvgVolumeLound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVolumeLound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/volume_lound.18cd3a4f.svg";
export { ForwardRef as ReactComponent };